export const MODULES = [
  {
    id: 'interface',
    name: '🔧 จัดการ Interface',
    description: 'ตั้งชื่อพอร์ต, เปิด/ปิด, MTU',
    icon: '🔧',
    color: 'slate',
    detail: 'กำหนดชื่อพอร์ต เช่น ether1=WAN, ether2=LAN',
  },
  {
    id: 'bridge',
    name: '🔗 Bridge',
    description: 'รวมพอร์ต, VLAN, Trunk/Access',
    icon: '🔗',
    color: 'cyan',
    detail: 'รวมพอร์ตเป็นเครือข่ายเดียวกัน + VLAN Filtering',
  },
  {
    id: 'internet',
    name: '🌐 อินเทอร์เน็ต (WAN)',
    description: 'PPPoE, DHCP, Static, VPN',
    icon: '🌐',
    color: 'blue',
    detail: 'เชื่อมต่อ WAN ไปยังผู้ให้บริการ',
  },
  {
    id: 'vlans',
    name: '🔀 VLAN',
    description: 'แยกเครือข่ายตามแผนก',
    icon: '🔀',
    color: 'purple',
    detail: 'สร้าง VLAN แยกเครือข่ายย่อย',
  },
  {
    id: 'dhcp',
    name: '📡 DHCP Server',
    description: 'แจก IP อัตโนมัติ',
    icon: '📡',
    color: 'green',
    detail: 'ตั้งค่า DHCP แจก IP ให้ลูกข่าย',
  },
  {
    id: 'timentp',
    name: '🕐 เวลา/NTP',
    description: 'Time Zone, NTP Client',
    icon: '🕐',
    color: 'indigo',
    detail: 'ตั้งค่าเขตเวลา + ซิงค์ NTP',
  },
  {
    id: 'firewall',
    name: '🛡️ Firewall & NAT',
    description: 'Filter, NAT, Port Forward',
    icon: '🛡️',
    color: 'red',
    detail: 'กฎกรองแพ็กเก็ต + Source/Destination NAT + Port Forward',
  },
  {
    id: 'vpn',
    name: '🔐 VPN Server',
    description: 'PPTP, L2TP, SSTP, OpenVPN Server',
    icon: '🔐',
    color: 'violet',
    detail: 'ตั้งค่า VPN Server ให้ลูกข่ายเชื่อมต่อจากภายนอก',
  },
  {
    id: 'portforward',
    name: '🔌 เปิดพอร์ต (Port Forward)',
    description: 'ส่งต่อพอร์ตจากภายนอกเข้าเครื่องภายใน',
    icon: '🔌',
    color: 'orange',
    detail: 'อนุญาตการเชื่อมต่อจากภายนอกเข้าเซิร์ฟเวอร์ภายใน',
  },
  {
    id: 'security',
    name: '🔒 Security Hardening',
    description: 'ปิด Service, Brute Force',
    icon: '🔒',
    color: 'rose',
    detail: 'ปิด api/ftp/telnet, เปลี่ยนพอร์ต, บล็อก Brute Force',
  },
  {
    id: 'qos',
    name: '🚦 QoS / จำกัดความเร็ว',
    description: 'ควบคุมแบนด์วิดท์',
    icon: '🚦',
    color: 'yellow',
    detail: 'จำกัดความเร็วต่อผู้ใช้/เครือข่าย',
  },
  {
    id: 'hotspot',
    name: '📶 Hotspot',
    description: 'หน้าล็อกอิน WiFi',
    icon: '📶',
    color: 'pink',
    detail: 'Captive Portal ให้ผู้ใช้ล็อกอิน',
  },
  {
    id: 'loadbalance',
    name: '⚖️ Load Balance',
    description: 'หลาย WAN, Failover',
    icon: '⚖️',
    color: 'teal',
    detail: 'กระจายทราฟฟิก + สลับอัตโนมัติ',
  },
  {
    id: 'logging',
    name: '📝 ระบบ Log',
    description: 'เก็บ Log, Syslog',
    icon: '📝',
    color: 'amber',
    detail: 'เก็บ Log + ส่งไป Syslog Server',
  },
  {
    id: 'websiteblock',
    name: '🚫 บล็อกเว็บไซต์',
    description: 'บล็อกการเข้าถึงเว็บไซต์ที่ไม่ต้องการ',
    icon: '🚫',
    color: 'red',
    detail: 'เลือกเว็บไซต์ที่จะบล็อก หรือเพิ่มเอง',
  },
];

export function getStepTitle(stepKey) {
  const titles = {
    select: 'เลือกหัวข้อที่ต้องการตั้งค่า',
    interface: 'จัดการ Interface',
    bridge: 'Bridge (รวมพอร์ต)',
    internet: 'อินเทอร์เน็ต (WAN)',
    vlans: 'VLAN',
    dhcp: 'DHCP Server',
    timentp: 'เวลา/NTP',
    firewall: 'Firewall & NAT',
    vpn: 'VPN Server',
    portforward: 'เปิดพอร์ต (Port Forward)',
    security: 'Security Hardening',
    qos: 'QoS / จำกัดความเร็ว',
    hotspot: 'Hotspot',
    loadbalance: 'Load Balance',
    logging: 'ระบบ Log',
    websiteblock: 'บล็อกเว็บไซต์',
    review: 'ตรวจสอบและสร้างสคริปต์',
    output: 'สคริปต์ที่สร้างแล้ว',
  };
  return titles[stepKey] || stepKey;
}

export function getStepIcon(stepKey) {
  const icons = {
    select: '📋',
    interface: '🔧',
    bridge: '🔗',
    internet: '🌐',
    vlans: '🔀',
    dhcp: '📡',
    firewall: '🛡️',
    vpn: '🔐',
    portforward: '🔌',
    hotspot: '📶',
    loadbalance: '⚖️',
    qos: '🚦',
    timentp: '🕐',
    logging: '📝',
    websiteblock: '🚫',
    review: '✅',
    output: '📄',
  };
  return icons[stepKey] || '📋';
}

export const COLOR_MAP = {
  slate: 'bg-slate-50 text-slate-700 border-2 border-slate-200 dark:bg-slate-900/30 dark:text-slate-300 dark:border-slate-700',
  cyan: 'bg-cyan-50 text-cyan-700 border-2 border-cyan-200 dark:bg-cyan-900/30 dark:text-cyan-300 dark:border-cyan-700',
  blue: 'bg-blue-50 text-blue-700 border-2 border-blue-200 dark:bg-blue-900/30 dark:text-blue-300 dark:border-blue-700',
  purple: 'bg-purple-50 text-purple-700 border-2 border-purple-200 dark:bg-purple-900/30 dark:text-purple-300 dark:border-purple-700',
  green: 'bg-green-50 text-green-700 border-2 border-green-200 dark:bg-green-900/30 dark:text-green-300 dark:border-green-700',
  red: 'bg-red-50 text-red-700 border-2 border-red-200 dark:bg-red-900/30 dark:text-red-300 dark:border-red-700',
  orange: 'bg-orange-50 text-orange-700 border-2 border-orange-200 dark:bg-orange-900/30 dark:text-orange-300 dark:border-orange-700',
  pink: 'bg-pink-50 text-pink-700 border-2 border-pink-200 dark:bg-pink-900/30 dark:text-pink-300 dark:border-pink-700',
  teal: 'bg-teal-50 text-teal-700 border-2 border-teal-200 dark:bg-teal-900/30 dark:text-teal-300 dark:border-teal-700',
  yellow: 'bg-yellow-50 text-yellow-700 border-2 border-yellow-200 dark:bg-yellow-900/30 dark:text-yellow-300 dark:border-yellow-700',
  indigo: 'bg-indigo-50 text-indigo-700 border-2 border-indigo-200 dark:bg-indigo-900/30 dark:text-indigo-300 dark:border-indigo-700',
  amber: 'bg-amber-50 text-amber-700 border-2 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-700',
  rose: 'bg-rose-50 text-rose-700 border-2 border-rose-200 dark:bg-rose-900/30 dark:text-rose-300 dark:border-rose-700',
  violet: 'bg-violet-50 text-violet-700 border-2 border-violet-200 dark:bg-violet-900/30 dark:text-violet-300 dark:border-violet-700',
};

export const COLOR_SELECTED_MAP = {
  slate: 'bg-slate-600 text-white border-2 border-slate-600 shadow-lg shadow-slate-500/30 scale-[1.02]',
  cyan: 'bg-cyan-600 text-white border-2 border-cyan-600 shadow-lg shadow-cyan-500/30 scale-[1.02]',
  blue: 'bg-blue-600 text-white border-2 border-blue-600 shadow-lg shadow-blue-500/30 scale-[1.02]',
  purple: 'bg-purple-600 text-white border-2 border-purple-600 shadow-lg shadow-purple-500/30 scale-[1.02]',
  green: 'bg-green-600 text-white border-2 border-green-600 shadow-lg shadow-green-500/30 scale-[1.02]',
  red: 'bg-red-600 text-white border-2 border-red-600 shadow-lg shadow-red-500/30 scale-[1.02]',
  orange: 'bg-orange-600 text-white border-2 border-orange-600 shadow-lg shadow-orange-500/30 scale-[1.02]',
  pink: 'bg-pink-600 text-white border-2 border-pink-600 shadow-lg shadow-pink-500/30 scale-[1.02]',
  teal: 'bg-teal-600 text-white border-2 border-teal-600 shadow-lg shadow-teal-500/30 scale-[1.02]',
  yellow: 'bg-yellow-600 text-white border-2 border-yellow-600 shadow-lg shadow-yellow-500/30 scale-[1.02]',
  indigo: 'bg-indigo-600 text-white border-2 border-indigo-600 shadow-lg shadow-indigo-500/30 scale-[1.02]',
  amber: 'bg-amber-600 text-white border-2 border-amber-600 shadow-lg shadow-amber-500/30 scale-[1.02]',
  rose: 'bg-rose-600 text-white border-2 border-rose-600 shadow-lg shadow-rose-500/30 scale-[1.02]',
  violet: 'bg-violet-600 text-white border-2 border-violet-600 shadow-lg shadow-violet-500/30 scale-[1.02]',
};
